module.exports = __webpack_public_path__ + "img/discovery_box_teaser_background.32af5796.svg";